import { IDocs } from 'models/notification';

import { NOTIFICATION_TYPE } from './notificationRedirect';

type NotificationVisibilityFields = Pick<IDocs, 'type' | 'active' | 'expirationDate'>;

export function isVisibleNotificationDoc(doc: NotificationVisibilityFields): boolean {
  if (doc.type !== NOTIFICATION_TYPE.EXCECAO) {
    return true;
  }

  if (doc.active === false) {
    return false;
  }

  if (doc.expirationDate) {
    return new Date(doc.expirationDate) > new Date();
  }

  return true;
}

export function filterNotificationDocs<T extends NotificationVisibilityFields>(docs: T[]): T[] {
  return docs.filter(isVisibleNotificationDoc);
}

export function countUnopenedVisibleNotifications(docs: IDocs[]): number {
  return filterNotificationDocs(docs).filter((doc) => !doc.opened).length;
}
